export default __webpack_public_path__ + "static/media/new.d3c87187.svg";